import req from './request'

const DEFAULT_ENDPOINTS = {
    parks: '/dashboard/ai/parks',
    parksReference: '/dashboard/ai/parks/reference',
    parksWorkRules: '/dashboard/ai/parks/work-rules'

}
export default {
    parks(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.parks, param)
    },
    parksReference(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.parksReference, param)
    },
    parksWorkRules(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.parksWorkRules, param)
    },
}